export default "__VITE_ASSET__db366b60__"